<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-alert dense type="error" outlined text dismissible transition="slide-x-transition"
          class="py-0 text-uppercase" v-for="(item, index) in storeErrors" :key="index">
          {{ item[0] }}
        </v-alert>
        <v-text-field outlined dense hide-details="auto" label="Stock Code" required v-model="stockCode"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field outlined dense hide-details="auto" label="Barcode" v-model="barcode" clearable></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-autocomplete outlined hide-details="auto" dense :loading="stockBrandTypeData.loading" label="Brand Type"
          :items="stockBrandTypeData.items" v-model="stockBrandType" item-value="id">
          <template v-slot:selection="{ item }">
            {{ item?.name || 'Select Brand Type' }}
          </template>
          <template v-slot:item="{ item }">
            {{ item.name }}
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="6">
        <v-text-field outlined dense hide-details="auto" label="Brand Name" required v-model="brandName"></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field outlined dense hide-details="auto" label="Product Name" required
          v-model="productName"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-textarea outlined dense hide-details="auto" v-model="description" auto-grow color="teal" rows="1" no-resize>
          <template v-slot:label>
            <div>
              Description <small>(optional)</small>
            </div>
          </template>
        </v-textarea>
      </v-col>
      <v-col cols="6">
        <v-text-field outlined dense hide-details="auto" label="Retail Price" type="number" required prefix="₱"
          v-model="retail"></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-autocomplete outlined dense hide-details="auto" v-model="unit" item-value="unit" label="Unit"
          :items="computedUnits">
          <template v-slot:selection="{ item }">
            {{ item.unit }}
          </template>
          <template v-slot:item="{ item }">
            {{ item.unit }} - {{ item.description }}
          </template>
        </v-autocomplete>
        <!-- <v-select
            :items="computedUnits"
            :search-input.sync="searchInput"
            item-value="unit"
            v-model="unit"
            name="units"
            label="Unit"
          >
          <template v-slot:selection="{ item }">
            {{ item.unit }}
          </template>
          <template v-slot:item="{ item }">
           {{ item.unit }} - {{ item.description }}
          </template>
        </v-select> -->
      </v-col>
      <v-col cols="2" align-self="end">
        <v-btn color="blue" @click="initStore" :loading="storing">Save</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import indexKeyGenerator from '@/extra-functions/index-key-generator.extra'
import appAxios from '@/extra-functions/axios.extra'
import { ErrorPopup, useWatchEffect } from '../../../../lib/utils'
import { debugLog } from '../../../../lib/electron-utils'

const [watchEffect, clearWatchEffect] = useWatchEffect()

export default {
  name: 'vCreateStock',
  data() {
    return {
      stockCode: null,
      barcode: null,
      brandName: null,
      unit: null,
      retail: null,
      productName: null,
      stockBrandType: null,
      description: null,
      searchInput: null,
      stockBrandTypeData: {
        loading: false,
        items: [],
      },
    }
  },
  computed: {
    ...mapState({
      storeSuccess: state => state.stock.storeSuccess,
      storing: state => state.stock.storing,
      storeErrors: state => state.stock.storeErrors,
      units: state => state.unit.allList,
      storeId: state => state.settings.storeId,
      authToken: state => state.auth.token,
    }),
    computedUnits() {
      return this.units.map(e => {
        return {
          ...e,
          displayText: `${e.unit} - ${e.description}`,
        }
      })
    },
  },
  watch: {
    storeSuccess(val) {
      if (val) {
        this.closeDialog()
      }
    },
  },
  created() {
    this.getStockBrandTypes()
  },
  beforeDestroy() {
    console.log('stock create beforeDestroy')
    clearWatchEffect()
  },
  methods: {
    ...mapActions({
      store: 'stock/store',
    }),
    closeDialog() {
      this.$emit('close-dialog')
    },
    initStore() {
      const data = {
        id: indexKeyGenerator(),
        store_id: this.storeId,
        barcode: this.barcode,
        stock_code: this.stockCode,
        brand_name: this.brandName,
        stock_brand_type: this.stockBrandType,
        unit: this.unit,
        retail: this.retail,
        product_name: this.productName,
        description: this.description,
      }
      this.store(data)
    },
    getStockBrandTypes(retries = 0) {
      watchEffect(async (onCleanup) => {
        try {
          this.stockBrandTypeData = {
            ...this.stockBrandTypeData,
            loading: true,
          }
          const controller = new AbortController()
          onCleanup(() => {
            controller.abort()
          })
          const axios = appAxios(this.authToken)
          const { data } = await axios.get('/stock-brand-types', {
            signal: controller.signal,
          })
          this.stockBrandTypeData = {
            ...this.stockBrandTypeData,
            items: data,
          }
        } catch (e) {
          debugLog(e)
          console.error(e)
          if (retries >= 5) {
            ErrorPopup.fire({ text: 'Oops something went wrong fetching brand types failed to reconnect 5 times!!!' })
            return
          }
          ErrorPopup.fire({ text: 'Oops something went wrong fetching brand types retrying in 5 secs!!!' })
          setTimeout(() => {
            this.getStockBrandTypes(retries + 1)
          }, 5000)
        } finally {
          this.stockBrandTypeData = {
            ...this.stockBrandTypeData,
            loading: false,
          }
        }
      }, 'STOCK_CREATE_GET_STOCK_BRAND_TYPES_METHODS')
    },
  },
}
</script>
